import TasksTabs from "./_TasksTabs";
import AppLayout from "@/layouts/AppLayout";
import PageHeading from "@/components/PageHeading";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";
import usePageTitle from "@/hooks/usePageTitle";

export default function TasksPage() {
  useRequireCapability({
    domain: DOMAIN.TASKS,
    permission: PERMISSION.viewTasks
  });
  usePageTitle("/tasks", "Tasks");

  return (
    <AppLayout bottomBar>
      <PageHeading title="Tasks" />
      <TasksTabs />
    </AppLayout>
  );
}
